/* Bolitas de color de las tarjetas: esconde las que no caben en la fila y pone el «+N» (snippets/color-dots.liquid).
   03/11/2026: antes cada cambio de la página volvía a medir TODAS las tarjetas bolita a bolita (cientos de lecturas de layout seguidas: en el móvil
   la colección de camisetas se quedaba congelada al hacer scroll). Ahora: se lee todo de una vez y se escribe de una vez, solo se tocan las tarjetas
   nuevas y se vuelve a medir todo únicamente si cambia el ancho de la pantalla. */
(function () {
  if (window.__impDots) return;
  window.__impDots = 1;
  var masW = 0, pendientes = [], rafId = 0;

  function procesa(filas) {
    var items = [];
    filas.forEach(function (c) {
      var dots = [].slice.call(c.querySelectorAll('.color-dot:not(.color-dot--more)')), mas = c.querySelector('.color-dot--more');
      if (dots.length && mas) items.push({ c: c, dots: dots, mas: mas });
    });
    if (!items.length) return;
    items.forEach(function (it) { for (var i = 0; i < it.dots.length; i++) it.dots[i].style.display = ''; it.mas.style.display = 'none'; });   // 1) escribir: todas visibles
    items.forEach(function (it) {                                                                                                         // 2) leer
      var c = it.c; it.W = c.clientWidth;
      it.nowrap = !!it.W && getComputedStyle(c).flexWrap === 'nowrap';   // en la lista del móvil las bolitas hacen varias filas
      if (!it.nowrap) return;
      var x0 = c.getBoundingClientRect().left;
      it.r = it.dots.map(function (d) { return d.getBoundingClientRect().right - x0; });
      it.gap = it.dots.length > 1 ? it.r[1] - it.r[0] - it.dots[1].offsetWidth : 0;
    });
    if (!masW) {
      var p = items.filter(function (it) { return it.nowrap && it.r[it.r.length - 1] > it.W; })[0];
      if (p) { p.mas.textContent = '+99'; p.mas.style.display = ''; masW = p.mas.getBoundingClientRect().width; p.mas.style.display = 'none'; }
    }
    items.forEach(function (it) {                                                                                                         // 3) escribir
      if (!it.nowrap || it.r[it.r.length - 1] <= it.W) return;                                                                          // caben todas
      var n = it.dots.length - 1;
      while (n > 1 && it.r[n - 1] + it.gap + (masW || 28) > it.W - 12) n--;
      for (var i = 0; i < it.dots.length; i++) it.dots[i].style.display = i < n ? '' : 'none';
      it.mas.textContent = '+' + (it.dots.length - n); it.mas.style.display = '';
    });
    items.forEach(function (it) { it.c.setAttribute('data-dd', it.W); });
  }

  function todas() { procesa([].slice.call(document.querySelectorAll('.color-dots'))); }
  function nuevas() {
    rafId = 0;
    var l = [].slice.call(document.querySelectorAll('.color-dots:not([data-dd])'));
    if (l.length) procesa(l);
  }
  function luego() { if (!rafId) rafId = requestAnimationFrame(nuevas); }
  var t; function alRedimensionar() { clearTimeout(t); t = setTimeout(todas, 150); }

  document.addEventListener('DOMContentLoaded', todas);
  window.addEventListener('load', todas);
  window.addEventListener('resize', alRedimensionar);
  if (window.MutationObserver) new MutationObserver(function (ms) {
    for (var i = 0; i < ms.length; i++) for (var j = 0; j < ms[i].addedNodes.length; j++) {
      var n = ms[i].addedNodes[j];
      if (n.nodeType === 1 && (n.matches && n.matches('.color-dots') || n.querySelector && n.querySelector('.color-dots'))) { luego(); return; }
    }
  }).observe(document.body, { childList: true, subtree: true });
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(todas);   // la letra del «+N» cambia de ancho al cargar
  todas();
})();
